// extracted by mini-css-extract-plugin
module.exports = {"toast":"cvF-","top":"xc6Y","title":"P1X3","text":"RmiF","inputSection":"zjG-","addButton":"SiQT","phoneNumber":"_6OsO","notificationType":"R-7Z","orText":"_1fDm"};